<template>
  <div class="bg-white rounded-lg m-3">
    <div class="border-b-0.5 flex justify-between items-center">
      <p class="text-sm font-semibold">{{ title }} h</p>
    </div>

    <transition name="fade">
      <div
        v-if="get_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ get_error }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="edit_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ edit_error }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="delete_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ delete_error }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="create_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ create_error }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="create_success"
        class="p-1 text-center text-sm w-full bg-green-200"
      >
        {{ create_success }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="delete_success"
        class="p-1 text-center text-sm w-full bg-green-200"
      >
        {{ delete_success }}
      </div>
    </transition>

    <!-- Display benefit groups -->
    <div v-if="benefitGroups.length" class="py-5">
      <div class="w-full">
        <div v-for="group in benefitGroups" :key="group.BenefitGroupId">
          <!-- {{ benefitGroups }} -->
          <div class="bg-white rounded-lg m-3 p-3">
            <input
              type="checkbox"
              :id="group.BenefitGroupId"
              @change="assignEmployeeBenefitGroup($event, group.BenefitGroupId)"
              :checked="isAssigned(group.BenefitGroupId)"
            />

            <label
              :for="group.BenefitGroupId"
              :title="group.Description"
              class="font-extrabold mb-2 ml-1 cursor-pointer"
              >{{ group.Name || "No Group" }}
            </label>
            <div class="border-b-0.5 mt-2 mb-2"></div>
            <div
              class="grid lg:grid-cols-4 justify-start gap-y-4 w-full text-sm"
            >
              <div v-for="benefit in group.Benefits" :key="benefit.BenefitId">
                <input
                  type="checkbox"
                  :id="benefit.BenefitId"
                  :checked="assignedIds.includes(group.BenefitGroupId)"
                  class="cursor-not-allowed"
                  disabled
                />
                <label :for="benefit.BenefitId" class="ml-1">{{
                  benefit.BenefitName
                }}</label>
              </div>
              <p class="text-center p-2" v-if="!group.Benefits.length">
                No Benefits
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import Loader from "@/components/loader/loader.vue";

import axios from "axios";
export default {
  name: "leavessInfoCard",
  props: ["title", "data"],
  // components: { Loader },
  data() {
    return {
      tabTitle: null,
      edit_error: null,
      assetTypes: null,
      create_success: null,
      create_error: null,
      get_error: null,
      assetTypeInfo: null,
      assetsAssigned: [],
      organizationBenefits: [],
      myBenefits: [],
      assignedIds: [],
      employeeIdSelected: null,
      employees: [],
      delete_error: null,
      delete_success: null,
      benefitGroups: [],
      benefitGroupId: "",
      columns: [
        {
          field: "",
          key: "a",
          title: "#",
          width: 50,
          align: "left",

          operationColumn: true,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            row, column, h;
            return ++rowIndex;
          },
        },
        {
          field: "Name",
          key: "name",
          title: "benefit Workflow Name",
          align: "left",
          edit: true,

          renderBodyCell: ({ row, column, rowIndex }, h) => {
            rowIndex, h, row, column;

            return (
              <el-select
                size="small"
                value={row["Name"]}
                on-input={(val) => {
                  row["Name"] = val;
                  this.cellDataChange(row, column, val);
                }}
                placeholder=""
              >
                {this.benefitWorkflows.map((workflow) => (
                  <el-option value={workflow.Name}>{workflow.Name}</el-option>
                ))}
              </el-select>
            );
          },
        },
      ],
    };
  },

  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getTabTitle",
      "getCurrentEmployeeId",
    ]),
  },

  watch: {
    benefitGroupId(newGroupId) {
      if (newGroupId) {
        this.assignEmployeeBenefitGroup(newGroupId);
      }
    },
  },

  methods: {
    isAssigned(benefitId) {
      console.log(benefitId);
      console.log(this.myBenefits);

      const isAssigned = this.myBenefits.some(
        ({ BenefitGroupId }) => BenefitGroupId === benefitId
      );

      // Check if benefitId is already in assignedIds array to prevent duplicates
      if (isAssigned && !this.assignedIds.includes(benefitId)) {
        this.assignedIds.push(benefitId);
      }

      return isAssigned;
    },

    handleClick(title) {
      //console.log(title);
      this.$store.commit("setTabTitle", title);
      return this.showEditEmployee();
    },

    // /{organization}/setup/benefit/v1/request
    getBenefits() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/benefit/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode == 200) {
              this.get_success = response.data.StatusMessage;
              this.organizationBenefits = response.data.Data;
              //console.log(this.organizationBenefits);
              this.loading = false;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;

            setTimeout(() => {
              this.showEditError = false;
            }, 2000);
          }
        );
    },

    // /{organization}/employee/benefit/v1/assign
    assignEmployeeBenefitGroup(event, benefitGroupId) {
      const isChecked = event.target.checked;
      this.loading = true;
      if (!isChecked) {
        this.deleteBenefitsAssignedToEmployee(benefitGroupId);
        return;
      }
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      const data = {
        EmployeeId: this.getCurrentEmployeeId,
        BenefitGroupId: benefitGroupId,
      };

      // /{organization}/employee/benefit/v1/assign
      axios
        .post(
          `${this.getOrganization}/employee/benefit/${this.$ApiVersion}/assign`,
          data,
          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode == 200) {
              this.loading = false;
              this.create_success = response.data.StatusMessage;
              this.getBenefitGroups();
              this.getEmployeeBenefitInfo(this.getCurrentEmployeeId);
              setTimeout(() => {
                this.create_success = null;
              }, 2500);
            } else {
              this.create_error = response.data.StatusMessage;
              this.getEmployeeBenefitInfo(this.getCurrentEmployeeId);
              this.loading = false;
              setTimeout(() => {
                this.create_error = null;
              }, 2500);
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
            setTimeout(() => {
              this.create_error = null;
            }, 2500);
          }
        );
    },

    // /{organization}/setup/benefit/v1/request
    getBenefitGroups() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/benefit/group/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              //console.log(response.data.Data);
              this.benefitGroups = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    // /{organization}/employee/benefit/v1/unassign
    deleteBenefitsAssignedToEmployee(benefitId) {
      const data = {
        EmployeeId: this.getCurrentEmployeeId,
        BenefitGroupId: benefitId,
      };
      this.loading = true;
      axios
        .delete(
          `${this.getOrganization}/employee/benefit/${this.$ApiVersion}/unassign`,
          {
            headers: {
              Authorization: `Bearer ${this.getToken}`,
              "Content-Type": "application/json",
            },
            data,
          }
        )
        .then(
          (response) => {
            if (response.data.StatusCode == 200) {
              this.loading = false;
              this.getEmployeeBenefitInfo(this.getCurrentEmployeeId);
              this.delete_success = response.data.StatusMessage;
              setTimeout(() => {
                this.delete_success = null;
              }, 2500);
            } else {
              this.loading = false;
              this.delete_error = response.data.StatusMessage;
              this.getEmployeeBenefitInfo(this.getCurrentEmployeeId);
            }
          },
          (error) => {
            this.loading = false;
            this.delete_error = error.message;
            setTimeout(() => {
              this.delete_error = null;
              this.getEmployeeBenefitInfo(this.getCurrentEmployeeId);
            }, 2500);
          }
        );
    },

    // /{organization}/employee/{employeeId}/compensation/benefit/v1/request
    getEmployeeBenefitInfo() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/${this.getCurrentEmployeeId}/compensation/benefit/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode == 200) {
              this.get_success = response.data.StatusMessage;
              this.myBenefits = response.data.Data.employeeBenefits;
              //console.log(this.myBenefits)
              this.loading = false;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
            setTimeout(() => {
              this.showEditError = false;
            }, 2000);
          }
        );
    },
  },

  created() {
    this.getBenefits();
    this.getBenefitGroups();
    this.getEmployeeBenefitInfo();
    this.tabTitle = this.getTabTitle.trim();
  },
};
</script>
